import FieldPopover from "../../../fields3/generic/popover/popover"

import FieldStoryPoints_Popover from "./components/popover/popover"
import FieldStoryPoints_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldStoryPoints_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldStoryPoints_View from "./render/view"
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldConfig from "../../proto/field-config"
import FieldStoryPoint_QuickFilterView from "./render/quick-filter-view"
import {
    ConditionType_IsNull,
    ConditionType_NotNull,
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan
} from "../../../model2/conditions/condition-types";
import FieldTaskStoryPoints_ConditionForm from "./render/condition";

const debug = false
// const debug = "FieldStoryPoints"

export default class FieldStoryPoints extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Story points"
        this.filterType         = null
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Story points selector"
        this.icon               = 'i5-story-points'

        this.isSearchable       = false;

        this.conditionTypes     = [
            ConditionType_NotNull, ConditionType_IsNull,
            ConditionType_NumberGreaterThan, ConditionType_NumberLessThan, ConditionType_NumberEquals
        ]

        _.assign(this.components, {
            PopoverMenu         : FieldStoryPoints_Popover,
            FormValueNotEmpty   : FieldStoryPoints_FormValueNotEmpty,
            InlineValueNotEmpty : FieldStoryPoints_InlineValueNotEmpty,
        })

        _.assign(this.renderComponents, {
            view                : FieldStoryPoints_View,
            viewSmall           : FieldStoryPoints_View,

            quickFilterView     : FieldStoryPoint_QuickFilterView,

            conditionForm       : FieldTaskStoryPoints_ConditionForm
        })
    }

    // /*** AUTOMATION (EXPERIMENTAL) ***/
    // get automation() {
    //
    //     if (!this._automation) {
    //         this._automation = new StoryPointsDropdownAutomation(this)
    //     }
    //
    //     return this._automation
    // }

    /*** DATA FUNCTIONS ***/

    groupValue(value:any) {
        const groupValue = typeof value === 'string' ? parseInt(value) : value
        debug && console.log(debug, 'groupValue', groupValue, _.isNil(groupValue), typeof groupValue)

        return groupValue
    }

    groupLabel(value:any) {
        const groupValue = this.groupValue(value)
        const groupLabel = _.isNaN(groupValue) ? 'Not set' : groupValue
        debug && console.log(debug, 'groupLabel', value, groupLabel)
        return groupLabel
    }

    getGroupObject(value: any) {
        const storyPoints = gd.session.companies.get(gd.companyId).settings.fields.storyPoints;
        const found = _.find(storyPoints, sp=>sp.value === value);

        return {
            id      : found ? found.value : value,
            value   : found ? found.value : value,
            label   : found ? found.label : value,
            name    : _.get(found, 'label', 'Not selected'),
        }
    }
}